import { useRef } from 'react';

import type { IconProps } from './base';
import { BaseIcon } from './base';

export type IconAiChatModeVariant = 'solid' | 'gradient';

export type IconAiChatModeProps = IconProps & {
  variant?: IconAiChatModeVariant;
};

let nextGradientId = 0;

export function IconAiChatMode({ variant = 'solid', ...props }: IconAiChatModeProps) {
  const gradientIdRef = useRef<string | null>(null);
  if (gradientIdRef.current === null) {
    nextGradientId += 1;
    gradientIdRef.current = `ai-chat-mode-gradient-${nextGradientId}`;
  }

  const gradientId = gradientIdRef.current;
  const fill = variant === 'gradient' ? `url(#${gradientId})` : 'currentColor';

  return (
    <BaseIcon {...props}>
      <path
        d="M14.35 20.6641L9 18.7891L4.35 20.5891C4.01667 20.7224 3.70833 20.6847 3.425 20.4761C3.14167 20.2681 3 19.9891 3 19.6391V5.63905C3 5.42238 3.06267 5.23072 3.188 5.06405C3.31267 4.89738 3.48333 4.77238 3.7 4.68905L8.35 3.11405C8.56667 3.04738 8.78333 3.00972 9 3.00105C9.21667 2.99305 9.43333 3.03072 9.65 3.11405L15 4.98905L19.65 3.18905C19.9833 3.05572 20.2917 3.09305 20.575 3.30105C20.8583 3.50972 21 3.78905 21 4.13905V18.1391C21 18.3557 20.9373 18.5474 20.812 18.7141C20.6873 18.8807 20.5167 19.0057 20.3 19.0891L15.65 20.6641C15.4333 20.7307 15.2167 20.7681 15 20.7761C14.7833 20.7847 14.5667 20.7474 14.35 20.6641ZM14 18.4391V6.73905L10 5.33905V17.0391L14 18.4391ZM16 18.4391L19 17.4391V5.58905L16 6.73905V18.4391ZM5 18.1891L8 17.0391V5.33905L5 6.33905V18.1891ZM16 6.73905V18.4391V6.73905ZM8 5.33905V17.0391V5.33905Z"
        fill={fill}
      />
      {variant === 'gradient' ? (
        <defs>
          <linearGradient
            id={gradientId}
            x1="3"
            y1="3"
            x2="24.1902"
            y2="15.2659"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#63D6FA" />
            <stop offset="1" stopColor="#E039CE" />
          </linearGradient>
        </defs>
      ) : null}
    </BaseIcon>
  );
}
